import { parseISO } from "date-fns";
import { format } from "date-fns-tz";
import { differenceInDays, isToday, isTomorrow } from "date-fns";
import { useEffect, useState } from "react";
import { getCountryCapital } from "../Events/utils";

interface Address {
	city: string;
	country: string;
	state?: string;
}

interface ICreateTimezone {
	dataCountry: {
		address: Address;
	};
	dataWeather: {
		current: {
			temperature_2m: number;
			interval?: string;
		};
		current_units: {
			time: string;
			interval: string;
			temperature_2m: string;
		};
	};
	dataTime: any;
	dataTimezone: string;
}

export const useFetchTimeZone = (timeZone: string) => {
	const [time, setTime] = useState<string>("");
	const [timezone, setTimezone] = useState<string>("");

	useEffect(() => {
		const currDate = new Date();
		let AuDate = new Date().toLocaleString("en-US", {
			timeZone: timeZone,
		});
		const timeString = format(AuDate, "hh:mm a", {
			timeZone: timeZone,
		});
		const timezoneName = format(currDate, "zzz", {
			timeZone: timeZone,
		});

		setTime(timeString);
		setTimezone(timezoneName);
		// const fetchTime = () => {

		// };

		// const interval = setInterval(fetchTime, 1000);

		// return () => clearInterval(interval);
	}, []);

	return { time, timezone };
};

export const calcPercentage = (x: number, y: number) => {
	return Math.round((x / y) * 100);
};

export const getTextRangeDisplay = (dateString: string) => {
	const date = parseISO(dateString);

	const today = new Date();

	let message;
	if (isToday(date)) {
		message = `Today`;
	} else if (isTomorrow(date)) {
		message = `Tomorrow`;
	} else if (differenceInDays(today, date) > 0) {
		message = `Until: ${differenceInDays(today, date)} days`;
	}

	return message;
};

export const formatDate = (date: string) => {
	const isDate = new Date(date);
	return isToday(isDate) ? "Today," : format(isDate, "EEEE,");
};

export const createTimezone = ({
	dataCountry,
	dataWeather,
	dataTime,
	dataTimezone,
}: ICreateTimezone) => {
	if (dataCountry && dataWeather && dataTime && dataTimezone) {
		const city = dataCountry?.address?.city;
		const isMultipleWords = city ? city.split(" ").length > 1 : false;
		return {
			address: `${
				!isMultipleWords
					? dataCountry?.address.city
						? dataCountry?.address.city
						: getCountryCapital(dataCountry.address.country)
					: getCountryCapital(dataCountry.address.country)
			}, ${dataCountry?.address.country}`,
			temperature_2m: dataWeather?.current?.temperature_2m,
			interval: dataWeather.current?.interval,
			current_units_time: dataWeather.current_units.time,
			current_units_interval: dataWeather.current_units.interval,
			current_units_temperature_2m: dataWeather?.current_units?.temperature_2m,
			time: dataTime,
			timezone: dataTimezone,
		};
	}
};
